import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_3 = { class: "card-body border-top p-9" }
const _hoisted_4 = { class: "row mb-6" }
const _hoisted_5 = { class: "col-lg-6 fv-row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Nama Bank", -1)
const _hoisted_7 = { class: "fv-plugins-message-container" }
const _hoisted_8 = { class: "fv-help-block" }
const _hoisted_9 = { class: "col-lg-6 fv-row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Penanggung Jawab", -1)
const _hoisted_11 = { class: "fv-plugins-message-container" }
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = { class: "row mb-6" }
const _hoisted_14 = { class: "col-lg-6 fv-row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Keterangan", -1)
const _hoisted_16 = { class: "fv-plugins-message-container" }
const _hoisted_17 = { class: "fv-help-block" }
const _hoisted_18 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_19 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Simpan ", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Silahkan Tunggu ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        id: "kt_account_profile_details_form",
        class: "form",
        novalidate: "novalidate",
        onSubmit: _cache[4] || (_cache[4] = ($event: any) => (_ctx.saveChanges1())),
        "validation-schema": _ctx.tambahBankValidator
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "name",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Nama Bank",
                  modelValue: _ctx.tambahBank.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tambahBank.name) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_ErrorMessage, { name: "name" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "picBank",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Penanggung Jawab",
                  modelValue: _ctx.tambahBank.picBank,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tambahBank.picBank) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_ErrorMessage, { name: "picBank" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _withDirectives(_createElementVNode("textarea", {
                  class: "form-control form-control-lg",
                  type: "text",
                  placeholder: "",
                  name: "note",
                  autocomplete: "off",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tambahBank.note) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.tambahBank.note]
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_ErrorMessage, { name: "note" })
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("button", {
              class: "btn btn-danger me-3",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/superadmin/bank-center')))
            }, " Batal "),
            _createElementVNode("button", _hoisted_19, _hoisted_22, 512)
          ])
        ]),
        _: 1
      }, 8, ["validation-schema"])
    ])
  ]))
}